import {GetServerSideProps} from "next";
import HeaderImageWithHeading from "../components/common/HeaderImageWithHeading";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {HeaderImages} from "../data/StaticImages";
import {useTranslation} from "next-i18next";
import {getSafeLocale} from "../helpers/LocalizeObject";


function Page() {

	const {t} = useTranslation();
	return <HeaderImageWithHeading
		imageSrc={HeaderImages[0]}
		title={t("pages.error.heading")!}
		subtitle={t("pages.error.subHeading")!}
	/>
}

export const getServerSideProps: GetServerSideProps = async (context) => {

	return {
		props: {
			...(await serverSideTranslations(getSafeLocale(context.locale) as string, ["common"]))
		},
	};
};

export default Page;